import styled from 'styled-components';
import StatusDefault, { getStatusColor, type StatusProps } from './StatusDefault';

const StyledStatus = styled(StatusDefault)`
    background:  linear-gradient(to top, ${getStatusColor} 50%, rgba(0, 0, 0, 0) 0%);
    border: 2px solid ${getStatusColor};
`;

function StatusHalfFilled(props: StatusProps) {
    return <StyledStatus {...props} />;
}

export default StatusHalfFilled;
